import React, { useEffect, useState, Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useSelector } from "react-redux"
import clsx from "clsx"
import { useLocation, useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import KtOrderNotes from "./KtOrderNotes"
import KtOrders from "./KtOrders"
import KtTableDetails from "./KtTableDetails"
// import KtCombineButton from "./KtCombineButton"
import { Button, IconButton, Navbar, } from "components"
import classes from "./index.module.scss"

const isMountedInitialState = [false, false]

const KtSidebar = props => {
  const {
    openTableSidebar,
    setOpenTableSidebar,
    tableOrders,
    setTableOrders,
    selectedTableId,
    selectedOrders,
    setSelectedOrders,
    showMoveTableMessage,
    setShowMoveTableMessage
  } = props

  const [t, i18n] = useTranslation()

  const location = useLocation()

  const history = useHistory()

  const tableDetails =
    useSelector(state =>
      state.kitchenTables.find(t => t._id === selectedTableId)
    )

  const [page, setPage] = useState("details")
  const [isMounted, setIsMounted] = useState(isMountedInitialState)

  const handleSelectTable = () => {
    setShowMoveTableMessage(true)
  }

  const handleGoToDetails = () => {
    setPage("details")
    setSelectedOrders({})
  }

  useEffect(() => {
    page === "details" &&
      setIsMounted(isMountedInitialState)
  }, [selectedTableId])

  const showHeaderButtons =
    !showMoveTableMessage &&
    Object.keys(selectedOrders).length >= 1

  const showRetrieves =
    !showHeaderButtons &&
    !showMoveTableMessage &&
    location.state.previousPage === "/foods"

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["sidebar"],
        isLtr && classes["sidebar-ltr"],
        openTableSidebar && classes["open"],
        openTableSidebar && isLtr && classes["open-ltr"]
      )}
    >
      <Navbar
        variant="compact"
        title={t("میز_های_رستوران")}
        onLeftIconPress={() =>
          history.push(location.state.previousPage)
        }
        rightSideComponent={() =>
          <button
            className={classes["close-button"]}
            onClick={() => setOpenTableSidebar(false)}
          >
            <MdClose size={20} />
          </button>
        }
      />
      {
        !!tableDetails &&
        <Fragment>
          {
            page !== "details" &&
            <div className={classes["topbar"]}>
              <IconButton
                icon={MdClose}
                className={classes["close"]}
                color="gray100"
                size={16}
                onClick={handleGoToDetails}
              />
              <b>
                {tableDetails.tableNumber}
              </b>
            </div>
          }
          {
            showHeaderButtons &&
            <div className={classes["header"]}>
              <Button
                color="warning"
                onClick={handleSelectTable}
              >
                {t("تغییر_میز")}
              </Button>
              {/* <KtCombineButton
                setTableOrders={setTableOrders}
                selectedOrders={selectedOrders}
                setSelectedOrders={setSelectedOrders}
              /> */}
            </div>
          }
          {
            page === "details" &&
            <KtTableDetails
              setPage={setPage}
              setIsMounted={setIsMounted}
              tableDetails={tableDetails}
              showRetrieves={showRetrieves}
            />
          }
          {
            isMounted[0] &&
            <div
              className={clsx(
                classes["tab"],
                page === "confirmed" && classes["show"]
              )}
            >
              <KtOrders
                setPage={setPage}
                tableOrders={tableOrders}
                setTableOrders={setTableOrders}
                selectedTableId={selectedTableId}
                tableDetails={tableDetails}
                selectedOrders={selectedOrders}
                setSelectedOrders={setSelectedOrders}
                showMoveTableMessage={showMoveTableMessage}
                setShowMoveTableMessage={setShowMoveTableMessage}
              />
            </div>
          }
          {
            isMounted[1] &&
            <div
              className={clsx(
                classes["tab"],
                page === "unconfirmed" && classes["show"]
              )}
            >
              <KtOrderNotes
                selectedTableId={selectedTableId}
                tableDetails={tableDetails}
              />
            </div>
          }
        </Fragment>
      }
    </div >
  )
}

export default KtSidebar